export default __webpack_public_path__ + "static/media/landing2.5cc62237.png";